export const interviewDocument = {
    addTitleForm: "Ajouter un rapport d'interview PDF",
    updateTitleForm: "Remplacer un rapport d'interview PDF",
    uploadNewDoc: "Télécharger",
    modifyDoc: "Remplacer",
    upload_title: "{{abbreviation}} {{location}} le {{audit_date}}",
}